// components/CookieConsentBanner.js
import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";

function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4"
      role="dialog"
      aria-labelledby="cookie-banner-text"
      aria-live="polite"
      aria-atomic="true"
    >
      <Card className="bg-kausora-blue-primary text-white shadow-lg max-w-5xl mx-auto">
        <div className="flex flex-wrap justify-between items-center gap-4 p-4">
          <p id="cookie-banner-text" className="flex-1 min-w-[200px] m-0 text-sm md:text-base">
            We use cookies to enhance your experience. Read our{" "}
            <button
              type="button"
              onClick={() => {
                window.open("/privacy-policy", "_blank", "noopener,noreferrer");
              }}
              aria-label="Read our privacy policy (opens in new window)"
              className="bg-transparent border-none text-blue-200 underline cursor-pointer p-0 font-inherit hover:text-blue-100 transition-colors"
            >
              Privacy Policy
            </button>
            .
          </p>
          <div className="flex gap-2" role="group" aria-label="Cookie consent options">
            <Button
              onClick={acceptCookies}
              aria-label="Accept cookies"
              className="bg-blue-300 text-black hover:bg-blue-200 font-bold"
              size="sm"
            >
              Accept
            </Button>
            <Button
              onClick={rejectCookies}
              aria-label="Reject cookies"
              variant="outline"
              className="border-blue-300 text-blue-300 hover:bg-blue-300/10 hover:text-blue-200"
              size="sm"
            >
              Reject
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default CookieConsentBanner;
